/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type PaginationResponse from "./PaginationResponse";
import type TestFarmerSampleResponse from "./TestFarmerSampleResponse";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type IdsRequest from "./IdsRequest";
import type ArchiveRequest from "./ArchiveRequest";
import type IdRequest from "./IdRequest";
import type FileContentResult from "./FileContentResult";
import type PendingSubmissionQueryFarmerSample from "./PendingSubmissionQueryFarmerSample";
import type SubmissionDataResponse from "./SubmissionDataResponse";
import type PrepareSubmissionFarmer from "./PrepareSubmissionFarmer";
import type DataRequest from "./DataRequest";
import type SubmissionDisplay from "./SubmissionDisplay";
import type Void from "./Void";
import type ManualFarmerSubmissionRequest from "./ManualFarmerSubmissionRequest";
import type ReportDataRequest from "./ReportDataRequest";
import type MfwSuccess from "./MfwSuccess";
import type PreReportData from "./PreReportData";
import type SubmissionReportDataFarmResponseApi from "./SubmissionReportDataFarmResponseApi";
import type FarmersSampleApiData from "./FarmersSampleApiData";
import type ReportDataResultFarm from "./ReportDataResultFarm";
import type UpdateReportDataRequestFarm from "./UpdateReportDataRequestFarm";

const urls = {
    pagedExcel(request: PaginationRequestSearch): string {
        return queryUrl("/api/farmerssample/pagedexcel", request);
    },
    questPdf(submissionIds: number[]): string {
        return queryUrl("/api/farmerssample/questpdf", {submissionIds});
    }
}

export default {
    urls,
    notCompleted(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestFarmerSampleResponse>>> {
        return Axios.post("/api/farmerssample/notcompleted", request, defaultConfig);
    },
    archiveFarmersSample(request: IdsRequest): Promise<AxiosResponse> {
        return Axios.post("/api/farmerssample/archivefarmerssample", request, defaultConfig);
    },
    restoreFarmersSample(request: IdsRequest): Promise<AxiosResponse> {
        return Axios.post("/api/farmerssample/restorefarmerssample", request, defaultConfig);
    },
    archive(request: ArchiveRequest): Promise<AxiosResponse> {
        return Axios.post("/api/farmerssample/archive", request, defaultConfig);
    },
    delete(request: IdRequest): Promise<AxiosResponse<boolean>> {
        return Axios.post("/api/farmerssample/delete", request, defaultConfig);
    },
    archived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestFarmerSampleResponse>>> {
        return Axios.post("/api/farmerssample/archived", request, defaultConfig);
    },
    completed(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestFarmerSampleResponse>>> {
        return Axios.post("/api/farmerssample/completed", request, defaultConfig);
    },
    getFarmerSampleResults(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestFarmerSampleResponse>>> {
        return Axios.post("/api/farmerssample/getfarmersampleresults", request, defaultConfig);
    },
    pagedExcel(request: PaginationRequestSearch): Promise<AxiosResponse<FileContentResult>> {
        return Axios.get(queryUrl("/api/farmerssample/pagedexcel", request), defaultConfig);
    },
    pendingSubmissions(requestSearch: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<PendingSubmissionQueryFarmerSample>>> {
        return Axios.post("/api/farmerssample/pendingsubmissions", requestSearch, defaultConfig);
    },
    prepareSubmission(request: DataRequest): Promise<AxiosResponse<SubmissionDataResponse<PrepareSubmissionFarmer>>> {
        return Axios.post("/api/farmerssample/preparesubmission", request, defaultConfig);
    },
    pagedWaiting(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/farmerssample/pagedwaiting", request, defaultConfig);
    },
    pagedCompleted(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/farmerssample/pagedcompleted", request, defaultConfig);
    },
    pagedArchived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/farmerssample/pagedarchived", request, defaultConfig);
    },
    pagedResults(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<SubmissionDisplay>>> {
        return Axios.post("/api/farmerssample/pagedresults", request, defaultConfig);
    },
    getSampleNumbersForSubmission(submissionId: number): Promise<AxiosResponse<string[]>> {
        return Axios.post("/api/farmerssample/getsamplenumbersforsubmission", submissionId, defaultConfig);
    },
    updateManualSubmission(request: ManualFarmerSubmissionRequest): Promise<AxiosResponse<Void>> {
        return Axios.post("/api/farmerssample/updatemanualsubmission", request, defaultConfig);
    },
    questPdf(submissionIds: number[]): Promise<AxiosResponse> {
        return Axios.get(queryUrl("/api/farmerssample/questpdf", {submissionIds}), defaultConfig);
    },
    submit(request: ReportDataRequest<PrepareSubmissionFarmer>): Promise<AxiosResponse<ReportDataRequest<PrepareSubmissionFarmer>>> {
        return Axios.post("/api/farmerssample/submit", request, defaultConfig);
    },
    postToMfw(request: IdRequest): Promise<AxiosResponse<MfwSuccess[]>> {
        return Axios.post("/api/farmerssample/posttomfw", request, defaultConfig);
    },
    preReport(request: IdsRequest): Promise<AxiosResponse<PreReportData<SubmissionReportDataFarmResponseApi>>> {
        return Axios.post("/api/farmerssample/prereport", request, defaultConfig);
    },
    getApiData(request: IdRequest): Promise<AxiosResponse<FarmersSampleApiData>> {
        return Axios.post("/api/farmerssample/getapidata", request, defaultConfig);
    },
    updateReportData(reports: UpdateReportDataRequestFarm[]): Promise<AxiosResponse<ReportDataResultFarm[]>> {
        return Axios.post("/api/farmerssample/updatereportdata", reports, defaultConfig);
    }
}
